
import { Box, Button, Input, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { subtitleStyle, titleStyle } from "../../../components/RobotMap/_style";
import { useEffect, useState } from "react";
import { useListBuilding } from "../../../hooks/config-page";
import { showErrorToast } from "../../../utils/utils";
import { useConfigDetailRobot, useCreateRobotMutation, useUpdateRobotMutation } from "../../../hooks/config-page/robot";
import { RobotModel } from "../../../utils/const";


const robotModels = [
  {
    label: 'Swift',
    value: RobotModel.SWIFTBOT
  }, {
    label: 'T300',
    value: RobotModel.T300
  }, {
    label: 'Flashbot',
    value: RobotModel.FLASHBOT
  }, {
    label: 'CC1',
    value: RobotModel.CC1
  }
]
export default function EditRobotScreen({
  onSubmit,
  selectedBuildingId,
  hideTitle,
  robotId,
  onCancel
}: {
  onSubmit?: () => void,
  selectedBuildingId?: string,
  hideTitle?: boolean,
  robotId: string
  onCancel?: () => void
}) {
  const [serialNumber, setSerialNumber] = useState('')
  const [macAddress, setMacAddress] = useState('')
  const [robotType, setRobotType] = useState('delivery_robot')
  const [location, setLocation] = useState('')
  const [robotName, setRobotName] = useState('')
  const [robotModel, setRobotModel] = useState('')

  const { trigger: submitUpdateRobot } = useUpdateRobotMutation({
    id: robotId,
    onSuccess: () => {
      onSubmit?.()
    }
  })

  const { data: dataRobot } = useConfigDetailRobot({ id: robotId,  })
  const robotDetails = dataRobot?.robot
  
  useEffect(() => {
    if (robotDetails) {
      setRobotName(robotDetails.robot_name || '')
      setSerialNumber(robotDetails.robot_serial_number || '')
      setMacAddress(robotDetails.robot_mac || '')
      setRobotType(robotDetails.robot_type || '')
      // setRobotModel(robotDetails. || '')
    }
  },[robotDetails])
  

  const onBack = () => {
    // Handle back navigation
    onCancel?.()
  }

  useEffect(() => {
    if (selectedBuildingId) {
      setLocation(selectedBuildingId)
    }
  }, [selectedBuildingId])

  const validateForm = () => {
    if (!serialNumber || serialNumber.trim() === '') {
      showErrorToast('Please enter Serial Number')
      return false
    }
    if (!macAddress || macAddress.trim() === '') {
      showErrorToast('Please enter MAC Address')
      return false
    }
    if (!robotType || robotType.trim() === '') {
      showErrorToast('Please select Robot Type')
      return false
    }
    return true
  }

  const handleSubmit = () => {
    const isValid = validateForm()
    if (!isValid) {
      return
    }

    submitUpdateRobot({
      robot_name: robotName,
      serial_number: serialNumber,
      mac_address: macAddress,
      robot_type: robotType,
      robot_model: robotModel,
      // building_uuid: location
    })
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={2} sx={{ width: '100%', mx: 'auto' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '42px' }}>
          {!hideTitle && (
            <Box sx={{ display: 'flex', mb: '28px', flexDirection: 'column', gap: '6px' }}>
              <Typography sx={titleStyle}>Edit Robot</Typography>
              <Typography sx={subtitleStyle}>Please update the robot details below:</Typography>
            </Box>
          )}

          <Box sx={{ display: 'flex', mt: hideTitle ? '0px' : '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Robot Name:</Typography>
            <TextField value={robotName} onChange={(e) => setRobotName(e.target.value)} size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Serial No.:</Typography>
            <TextField value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>MAC Address:</Typography>
            <TextField value={macAddress} onChange={(e) => setMacAddress(e.target.value)} size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px', flex: 'none' }}>Robot Model:</Typography>
            <Select value={robotModel} onChange={(e) => setRobotModel(e.target.value)} sx={{ width: '100%' }} size="small">
              {robotModels.map((model) => (
                <MenuItem key={model.value} value={model.value}>{model.label}</MenuItem>
              ))}
            </Select>
          </Box>
          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px', flex: 'none' }}>Robot Type:</Typography>
            <Select value={robotType} onChange={(e) => setRobotType(e.target.value)} sx={{ width: '100%', flex: 'auto' }} size="small">
              <MenuItem value="delivery_robot">Delivery Robot</MenuItem>
              <MenuItem value="concierge_robot">Concierge Robot</MenuItem>
              <MenuItem value="clean_robot">Clean Robot</MenuItem>
              {/* <MenuItem value="other">Other</MenuItem> */}
            </Select>
          </Box>

          {/* <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Customer:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Customer Name:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Contact No.:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box> */}

          {/* <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Location:</Typography>
            <Select
              size='small'
              disabled={!!selectedBuildingId}
              displayEmpty
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              sx={{ flex: 'auto' }}
            >
              {listBuildings.map((building, index) => (
                <MenuItem
                  key={index}
                  value={building.building_uuid}
                  sx={{ textTransform: 'capitalize' }}
                >
                  {building.building_name}
                </MenuItem>
              ))}
            </Select>
          </Box> */}

          {/* <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>SLA Type:</Typography>
            <Select
              size='small'
              read
              displayEmpty
              sx={{ flex: 'auto' }}
            >
              <MenuItem
                value={'test1'}
                sx={{ textTransform: 'capitalize' }}
              >
                {'Type 1'}
              </MenuItem>
              <MenuItem
                value={'test2'}
                sx={{ textTransform: 'capitalize' }}
              >
                {'Type 2'}
              </MenuItem>
            </Select>
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Activation Date:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box>

          <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Lease Period:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box> */}

          {/* <Box sx={{ display: 'flex', mt: '14px', width: '80%', flexDirection: 'row', alignItems: 'center', gap: '16px', justifyContent: 'space-between' }}>
            <Typography sx={{ ...subtitleStyle, width: '310px' }}>Software Version:</Typography>
            <TextField size="small" sx={{ flex: 'auto' }} variant="outlined" />
          </Box> */}

        </Box>
      </Paper>
      <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', mt: '16px', gap: '12px', maxWidth: '1688px', width: '100%', mx: 'auto' }}>
        <Button onClick={() => onCancel?.()} variant="outlined" sx={{ paddingInline: '78px', paddingTop: '8px', paddingBottom: '8px' }}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" sx={{ paddingInline: '78px', paddingTop: '8px', paddingBottom: '8px', backgroundColor: '#378FFE' }}>Update Robot</Button>
      </Box>
    </Box>
  )
}